import React, { forwardRef } from 'react';
import { Text, StyleSheet, Platform, TouchableOpacity } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { colores, fuentes } from '../../../../styles/variablesCss';
import { useFavoritos } from '../../../../context/FavoritosContext';

const Favoritos = forwardRef(() => {
  return (
      <Text style={styles.tituloSeccion}>Tus favoritos</Text>
  );
});

// Componente de botón de favorito para usar en PlaceHolderProducto
export const BotonFavorito = ({ plu, size = 24, style }) => {
  const { esFavorito, toggleFavorito, loading: loadingFavoritos } = useFavoritos();

  return (
    <TouchableOpacity
      style={[styles.botonFavorito, style]}
      onPress={() => toggleFavorito(plu)}
      disabled={loadingFavoritos}
    >
      <MaterialCommunityIcons
        name={esFavorito(plu) ? 'heart' : 'heart-outline'}
        size={size}
        color={esFavorito(plu) ? colores.rojo : '#666'}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  center: { alignItems: 'center', justifyContent: 'center', paddingVertical: 20 },
  tituloSeccion: { fontFamily: fuentes.bold, fontSize: 18, color: colores.rojo },
  botonFavorito: {
    position: 'absolute',
    top: 5,
    right: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: 20,
    padding: 6,
    zIndex: 10,
    ...Platform.select({
      web: {
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
      },
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 3,
        elevation: 3,
      },
    }),
  },
});

export default Favoritos;
